import { Spinner } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { IReferenceNumberStore } from '../../../stores/ReferenceNumberStore';
import WarningNotice from '../notices/WarningNotice';

import ClosableModal from './ClosableModal';
import PaymentModal from './PaymentModal';

interface IMasterRefNumberPaymentModalProps {
  referenceNumberStore?: IReferenceNumberStore;
  headingLabel: string;
  amount: number;
  amountFieldLabel?: string;
  onRedirectToBank: (banklinkName: string) => void;
}

@inject('referenceNumberStore')
@observer
export default class MasterRefNumberPaymentModal extends React.Component<IMasterRefNumberPaymentModalProps> {
  public componentDidMount(): void {
    this.props.referenceNumberStore.tryLoadMasterReferenceNumber();
  }

  public render(): JSX.Element {
    if (this.props.referenceNumberStore.masterReferenceNumber.isInitialLoading) {
      return (
        <ClosableModal>
          <Spinner />
        </ClosableModal>
      );
    }

    if (this.props.referenceNumberStore.masterReferenceNumber.isFinishedWithError) {
      return (
        <ClosableModal>
          <WarningNotice translationKey="shared.payment-modal.errors.error-while-making-a-payment" />
        </ClosableModal>
      );
    }

    return (
      <PaymentModal
        amount={this.props.amount}
        headingLabel={this.props.headingLabel}
        referenceNumber={this.props.referenceNumberStore.masterReferenceNumber.payload}
        onRedirectToBank={(banklinkName) => this.props.onRedirectToBank(banklinkName)}
        amountFieldLabel={this.props.amountFieldLabel}
      />
    );
  }
}
